<template>
	<view>
		<image lazy-load :src="src" :mode="mode"  :style="style" v-if="src"></image>
		<view v-else :style="style" class="iconfont no-img flexs align-center " >&#xe62c;</view>
	</view>
</template>

<script>
	export default {
		name:"images",
		props:{
			src:{
				type:String,
				default:''
			},
			style:{
				type:String,
				default:''
			},
			mode:{
				type:String,
				default:'aspectFill'
			}
		},
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="scss" scoped scoped>
.no-img{
	background: #f3f3f3;
	font-size: 28px;
	color: #888888;
	justify-content: center;
}
</style>